(() => {
  const compare = (coatBust,coatHips,bust,hips) => { const bustRoom=Math.round((coatBust-bust)*100)/100,hipsRoom=Math.round((coatHips-hips)*100)/100; return {bust:bustRoom,hips:hipsRoom,passes:bustRoom>=2 && hipsRoom>=2}; };
  const init = root => {
    if(root.dataset.initialized) return;
    root.dataset.initialized='true';
    const select=root.querySelector('[data-lfp-variant]');
    const buy=root.querySelector('.lfp-buy-form');
    const details=root.querySelector('[data-lfc-fit]');
    const check=root.querySelector('[data-lfc-self-check]');
    const closeReview=()=>{
      details.open=false;
      details.querySelector('summary').focus({preventScroll:true});
    };
    root.querySelectorAll('[data-lfc-dismiss]').forEach(button=>button.addEventListener('click',closeReview));
    details.addEventListener('keydown',event=>{
      if(event.key==='Escape' && details.open){event.preventDefault();closeReview();}
    });
    const format=value=>Number(value.toFixed(2)).toLocaleString(undefined,{maximumFractionDigits:2});
    const updateVariant=()=>{
      const selected=select.selectedOptions[0];
      const paymentVariant = root.querySelector('[data-lfp-payment-variant]');
      if (paymentVariant && paymentVariant.value !== selected.value) {
        paymentVariant.value = selected.value;
        paymentVariant.setAttribute('value', selected.value);
        paymentVariant.dispatchEvent(new Event('change', {bubbles:true}));
      }
      const paymentTerms = root.querySelector('.lfp-payment-terms shopify-payment-terms');
      if (paymentTerms) paymentTerms.setAttribute('variant-id', selected.value);
      const available=selected.dataset.available==='true';
      const stock=selected.dataset.sku || root.dataset.stockFallback;
      root.querySelector('[data-lfp-price]').textContent=selected.dataset.price;
      root.querySelector('[data-lfp-stock]').textContent=available ? root.dataset.inStock : root.dataset.unavailable;
      root.querySelector('[data-lfc-stock-number]').textContent=stock;
      const button=root.querySelector('[data-lfp-add]');button.disabled=!available;button.textContent=available ? root.dataset.addLabel : root.dataset.soldLabel;
      const assign=(selector,value)=>{const input=root.querySelector(selector);if(input)input.value=value;};
      assign('[data-lfc-contact-stock]',stock);assign('[data-lfc-contact-variant-id]',selected.value);assign('[data-lfc-contact-variant]',selected.textContent.trim());
      const canonical=new URL(root.dataset.productUrl);canonical.searchParams.set('variant',selected.value);assign('[data-lfc-contact-url]',canonical.href);
      const url=new URL(location.href);url.searchParams.set('variant',selected.value);history.replaceState({},'',url);
    };
    select.addEventListener('change',updateVariant);
    if(check) {
      check.querySelector('[data-lfc-inputs]').disabled=false;
      const resetVerdict=()=>{
        root.querySelector('[data-lfc-verdict]').textContent='';
        details.removeAttribute('data-fit-outcome');
        root.querySelectorAll('[data-lfc-body],[data-lfc-guide]').forEach(cell=>cell.textContent='—');
      };
      check.addEventListener('input',resetVerdict);
      check.addEventListener('submit',event=>{
        event.preventDefault();if(!check.reportValidity()) return;
        const bust=Number(check.elements.bust.value),hips=Number(check.elements.hips.value);
        if(!(Number.isFinite(bust)&&Number.isFinite(hips)&&bust>0&&hips>0))return;
        const result=compare(Number(details.dataset.bust),Number(details.dataset.hips),bust,hips);
        for(const key of ['bust','hips']){
          root.querySelector(`[data-lfc-body="${key}"]`).textContent=format(key==='bust'?bust:hips);
          root.querySelector(`[data-lfc-guide="${key}"]`).textContent=(result[key]>=2?details.dataset.meets:details.dataset.below)+' · '+format(result[key])+'″ '+details.dataset.extra;
        }
        root.querySelector('[data-lfc-verdict]').textContent=result.passes?details.dataset.positive:details.dataset.negative;
        details.dataset.fitOutcome=result.passes?'pass':'below';
      });
    }
    root.querySelectorAll('[data-lfp-media]').forEach(button=>button.addEventListener('click',()=>{
      const template=document.getElementById(button.dataset.lfpMedia);
      root.querySelector('[data-main-media]').replaceChildren(template.content.cloneNode(true));
      root.querySelectorAll('[data-lfp-media]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
    }));
    buy.addEventListener('submit',event=>{if(!buy.reportValidity())event.preventDefault();});
    updateVariant();
  };
  const scan=()=>document.querySelectorAll('[data-lfv-coat-product]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();
